import { all, take, put, race, select } from 'redux-saga/effects'
import { List } from 'immutable'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { error } from '../../../../../services/toastr'
import { openDialog } from '../../../../../services/dialog/actions'

import {
    deleteGroupMemberRequest,
    deleteAllGroupMembersRequest,
    setupGroupStack,
    loadGroupMembers,
    changeEntityStackGroupMembers,
} from '../actions'

import { groupStackSelector, groupMembersSelector } from '../selectors'

import { CONFIRM_DIALOG_ON_BUTTON_CLICK } from '../../../../../components/Dialog/components/Confirm/constants'

import { DELETE_GROUP_MEMBER_REQUEST, DELETE_ALL_GROUP_MEMBERS_REQUEST, LOCALE_PREFIX } from '../constants'

export default function* deleteGroupMemberSaga(_action) {
    const {
        data: { groupId, memberId },
    } = _action
    const { groupData } = yield select(groupStackSelector)
    let members = groupData.get('members')

    if (memberId) {
        const currentGroup = yield select(groupMembersSelector, groupId)
        if (!currentGroup) {
            error({
                id: `${LOCALE_PREFIX}.errorDuringDeletingMember`,
            })
            return null
        }

        const currentMembersCount = currentGroup.get('members', null)
        if (_.isNil(currentMembersCount)) {
            error({
                id: `${LOCALE_PREFIX}.errorDuringDeletingMember`,
            })
            return null
        }

        const nextMembersCount = currentMembersCount - 1

        yield put(setupGroupStack(groupId, { loading: true }))
        yield all({
            response: race({
                success: take(`${DELETE_GROUP_MEMBER_REQUEST(groupId)}_${SUCCESS}`),
                failed: take(`${DELETE_GROUP_MEMBER_REQUEST(groupId)}_${FAILED}`),
            }),
            request: put(deleteGroupMemberRequest(groupId, memberId, nextMembersCount)),
        })

        const { page, rows } = groupData
        const nextCount = members.count() - 1

        if (nextCount === 0) {
            const nextPage = page === 0 ? page : page - 1

            yield put(loadGroupMembers(groupId, nextPage, rows))
            yield put(changeEntityStackGroupMembers(groupId, nextCount))

            return null
        }

        yield put(setupGroupStack(groupId, { loading: false }))
        yield put(changeEntityStackGroupMembers(groupId, nextMembersCount))
        yield put(loadGroupMembers(groupId, page, rows))

        return null
    }

    const dialogSettings = {
        header: { textId: 'deleteGroupMembers', icon: 'warning' },
        question: {
            textId: 'deleteGroupMembers',
        },
        buttons: ['yes', 'no'],
    }

    const userResponse = yield all({
        answer: race({
            delete: take(CONFIRM_DIALOG_ON_BUTTON_CLICK('yes', groupId)),
            cancel: take(CONFIRM_DIALOG_ON_BUTTON_CLICK('no', groupId)),
        }),
        dialog: put(openDialog('confirm', groupId, dialogSettings)),
    })

    if (userResponse.answer.delete) {
        yield put(setupGroupStack(groupId, { loading: true }))

        yield all({
            response: race({
                success: take(`${DELETE_ALL_GROUP_MEMBERS_REQUEST}_${SUCCESS}`),
                failed: take(`${DELETE_ALL_GROUP_MEMBERS_REQUEST}_${FAILED}`),
            }),
            request: put(deleteAllGroupMembersRequest(groupId)),
        })
        members = List()
    }

    const nextGroupData = { ...groupData.toJS(), members, page: 0, pages: 1 }

    yield put(setupGroupStack(groupId, { loading: false }))
    yield put(changeEntityStackGroupMembers(groupId, 0))
    yield put(setupGroupStack(groupId, nextGroupData))

    return null
}
